import { useSearchParams } from '@/shared/hooks/useSearchParams';
import { QueryParameter } from '@/shared/constants/queryParams';

export const usePlayingContentId = () => {
    const searchParams = useSearchParams();

    const playingContentId = searchParams.get(QueryParameter.PLAYING_CONTENT_ID);
    const channelContentId = searchParams.get(QueryParameter.OPENED_CHANNEL_ID);

    if (typeof channelContentId === 'string') {
        return channelContentId;
    }

    if (typeof playingContentId === 'string') {
        return playingContentId;
    }

    return '';
};
